import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useStoreUrl } from "@/hooks/useStoreUrl";
import { useNavigate } from "react-router-dom";

const CONSENT_KEY = "cookie_consent_accepted";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const { storeUrl } = useStoreUrl();
  const navigate = useNavigate();

  useEffect(() => {
    const accepted = localStorage.getItem(CONSENT_KEY);
    if (!accepted) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, "true");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", damping: 25, stiffness: 300 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6"
        >
          <div className="mx-auto max-w-lg rounded-2xl border border-border bg-card p-4 shadow-xl flex flex-col sm:flex-row items-start sm:items-center gap-3">
            <Cookie className="h-5 w-5 text-primary shrink-0 mt-0.5 sm:mt-0" />
            <p className="text-xs text-muted-foreground flex-1 leading-relaxed">
              Usamos cookies para melhorar sua experiência. Ao continuar navegando, você concorda com nossa{" "}
              <button
                onClick={() => { navigate(storeUrl("/privacy")); accept(); }}
                className="underline text-primary hover:text-primary/80 transition-colors"
              >
                Política de Privacidade
              </button>.
            </p>
            <div className="flex gap-2 shrink-0">
              <Button size="sm" onClick={accept} className="text-xs h-8 rounded-lg px-4">
                Aceitar
              </Button>
              <Button size="sm" variant="ghost" onClick={accept} className="text-xs h-8 w-8 p-0">
                <X className="h-3.5 w-3.5" />
              </Button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
